import DOMPurify from 'dompurify';

// Whitelist stricte du descriptif : b,i,u,ul,ol,li,br,p,h3,a (+ strong/em équivalents)
// + attribut style limité à text-align (alignement par paragraphe, WYSIWYG éditeur/public/PDF)
const ALLOWED_TAGS = ['b', 'strong', 'i', 'em', 'u', 'p', 'br', 'ul', 'ol', 'li', 'h3', 'a'];
const ALLOWED_ATTR = ['href', 'target', 'rel', 'style'];

let hookInstalled = false;
const ensureStyleHook = () => {
  if (hookInstalled) return;
  hookInstalled = true;
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.hasAttribute && node.hasAttribute('style')) {
      const m = /text-align\s*:\s*(left|center|right|justify)/i.exec(node.getAttribute('style') || '');
      if (m) node.setAttribute('style', `text-align: ${m[1].toLowerCase()};`);
      else node.removeAttribute('style');
    }
  });
};

export const sanitizeDescriptionHtml = (html) => {
  if (!html) return '';
  ensureStyleHook();
  return DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });
};

export const looksLikeHtml = (s) =>
  typeof s === 'string' && /<\/?[a-z][\s\S]*>/i.test(s);

const escapeText = (t) =>
  t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

export const plainTextToHtml = (text) => {
  if (!text) return '';
  return text
    .split(/\n+/)
    .map((l) => l.trim())
    .filter(Boolean)
    .map((l) => `<p>${escapeText(l)}</p>`)
    .join('');
};

export const htmlToPlainText = (html) => {
  if (!html) return '';
  if (!looksLikeHtml(html)) return html;
  const div = document.createElement('div');
  div.innerHTML = sanitizeDescriptionHtml(html);
  return (div.textContent || '').replace(/\s+/g, ' ').trim();
};

export const isEmptyHtml = (html) => htmlToPlainText(html).length === 0;

// Rendu sécurisé : HTML assaini, ou texte simple converti en paragraphes
export const renderDescriptionHtml = (content) =>
  looksLikeHtml(content) ? sanitizeDescriptionHtml(content) : plainTextToHtml(content);
